<div class="two-column-layout indication-wrapper">
    <ng-container *ngFor="let indication of indications">
        <app-card
                [tabindex]="1"
                [cardPadding]="'32'"
                [cardInfo]="true"
                [cardInfoTitleIcon]="'eye'"
                [cardInfoTitle]="indication.indicationSpecialty | indicationSpecialtyTranslation"
                [cardMainTitle]="indication.title"
                [cardParagraph]="indication.description"
                [ariaLabel]="indication.title + ('GENERAL.DIAGNOSIS' | translate)"
                [disabled]="indication.indicationDisabled"
                (cardClickEvent)="indicationSelectedClick(indication)">
        </app-card>
    </ng-container>
</div>
